/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Members */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">MEMBERS</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end::section */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(
            "/identityverification",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/identityverification">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/Shield-check.svg")}
              />
            </span>
            <span className="menu-text">Identity Verification</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/users", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/users">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </span>
            <span className="menu-text">Restless Users</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* CONTENT */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">CONTENT</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end::section */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/posts", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/posts">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Layout/Layout-top-panel-6.svg"
                )}
              />
            </span>
            <span className="menu-text">Posts</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/articles", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/articles">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")} />
            </span>
            <span className="menu-text">Resources</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/media", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/media">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Media.svg")} />
            </span>
            <span className="menu-text">Media</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/notifications", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/notifications">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Notifications1.svg")} />
            </span>
            <span className="menu-text">Notifications</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/* INTERACTIONS */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">INTERACTIONS</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end::section */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/comments", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/comments">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Chat6.svg")}
              />
            </span>
            <span className="menu-text">Comments</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/hashtags", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/hashtags">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/tag_black_24dp.svg"
                )}
              />
            </span>
            <span className="menu-text">Hashtags</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/* REPORTS */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">REPORTS</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end::section */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/reports", false)}`}
          aria-haspopup="true"
        >
        <NavLink className="menu-link" to="/reports">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/Clipboard.svg")}
              />
            </span>
            <span className="menu-text">New Reported Content</span>
          </NavLink>
          </li>
          <li
          className={`menu-item ${getMenuItemActive("/reviewedreports", false)}`}
          aria-haspopup="true"
        >
        <NavLink className="menu-link" to="/reviewedreports">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Clipboard-check.svg")}
              />
            </span>
            <span className="menu-text">Reviewed Reported Content</span>
          </NavLink>
          </li>
        {/*end::1 Level*/}
        {/* ACTIVITY */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">ACTIVITY</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end::section */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/analytics", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/analytics">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Chat6.svg")}
              />
            </span>
            <span className="menu-text">Analytics</span>
          </NavLink>
        </li>
      </ul>
      {/*end::1 Level*/}
      {/* end::Menu Nav */}
    </>
  );
}
